import React, { useEffect } from 'react';
import Slides from 'components/main/Slides';
import Intro from 'components/main/Intro';
import Content from 'components/main/Content';
import Contact from 'components/main/Contact';
import { useSelector } from 'react-redux';

const MainPage = () => {
    const moreThan768 = useSelector((state) => state.moreThan768.value);

    // 스크롤 방향 감지
    useEffect(() => {
        let lastScrollY = 0;

        if (moreThan768) {
            const handleScroll = e => {
                const navbarEl = document.querySelector('.Navbar');
                const scrollY = window.scrollY;
                const direction = scrollY > lastScrollY ? 'scroll Down' : 'scroll Up';
                lastScrollY = scrollY;
                if (direction === 'scroll Down') {
                    navbarEl.classList.add('scrolled');
                } else if (direction === 'scroll Up') {
                    navbarEl.classList.remove('scrolled');
                }
            };

            handleScroll();
            window.addEventListener('scroll', handleScroll);
            return () => {
                window.removeEventListener('scroll', handleScroll);
            }
        } else {
            const navbarEl = document.querySelector('.Navbar');
            navbarEl.classList.remove('scrolled');
        }

    }, [moreThan768]);

    return (
        <section className="MainPage">
            <Slides moreThan768={moreThan768} />
            <section>
                <Intro moreThan768={moreThan768} />
                <Content />
                <Contact />
            </section>
        </section>
    );
};

export default React.memo(MainPage);